import {
  dateToString,
  parseafechainicioServicio,
  addOneMonth
} from "./formatoFechas";

export function generaJsonOperacion(idTblAmo, monto, naturaleza, concepto) {
  let operacion = {
    idTblAmo: idTblAmo,
    monto: (parseFloat(monto) || 0).toFixed(2),
    naturaleza: naturaleza,
    concepto: concepto,
    referencia: "REF" + getCurrentTimestamp()
  };
  return operacion;
}

function reformatData(inputData) {
  const output = { operaciones: [], updatesTblAmort: [] };

  inputData.forEach(item => {
    if (item.hasOwnProperty("tblUpdate")) {
      output.updatesTblAmort.push(...item.tblUpdate);
    } else {
      output.operaciones.push(item);
    }
  });

  return output;
}

function getCurrentTimestamp() {
  const now = new Date();
  const hours = now
    .getHours()
    .toString()
    .padStart(2, "0");
  const minutes = now
    .getMinutes()
    .toString()
    .padStart(2, "0");
  const seconds = now
    .getSeconds()
    .toString()
    .padStart(2, "0");
  const milliseconds = now
    .getMilliseconds()
    .toString()
    .padStart(3, "0");

  return `${hours}${minutes}${seconds}${milliseconds}`;
}
/*
export const generaOperaciones = (total, tblAmorOrig, MetodoPago) => {
  let tblNueva = [];
  total = parseFloat(total);
  let operaciones = [];
  if (tblAmorOrig.length > 0) {
    let entrada = generaJsonOperacion(0, total, "E", MetodoPago); //entrada
    operaciones.push(entrada);
  }

  for (let i = 0; i < tblAmorOrig.length; i++) {
    let montoInteres = parseFloat(tblAmorOrig[i].interes);
    let montoapagar = parseFloat(tblAmorOrig[i].montoapagar);
    let montoAnticipado = parseFloat(tblAmorOrig[i].anticipado);

    if (total <= 0) break;
    if (tblAmorOrig[i].estatus == "M") {
      if (montoInteres > 0) {
        if (total - montoInteres <= 0) {
          let interes = parseFloat(tblAmorOrig[i].interes);
          let montopagar = parseFloat(tblAmorOrig[i].montoapagar);
          tblAmorOrig[i].interes = Math.abs(
            parseFloat((total - montoInteres).toFixed(2))
          );
          let jsonInteres = generaJsonOperacion(
            tblAmorOrig[i].id,
            total,
            "S",
            5
          ); //PAGO INTERES MENSUALIDAD
          tblAmorOrig[i].moratorio = parseFloat(
            (interes + montopagar).toFixed(2)
          );
          operaciones.push(jsonInteres);
          break;
        } else {
          let interes = parseFloat(tblAmorOrig[i].interes);
          let montopagar = parseFloat(tblAmorOrig[i].montoapagar);
          let jsonInteres = generaJsonOperacion(
            tblAmorOrig[i].id,
            tblAmorOrig[i].interes,
            "S",
            5
          ); //PAGO INTERES MENSUALIDAD
          tblAmorOrig[i].interes = 0;
          tblAmorOrig[i].moratorio = parseFloat(
            (interes + montopagar).toFixed(2)
          );
          operaciones.push(jsonInteres);
          total = parseFloat((total - montoInteres).toFixed(2));
        }
      }
      if (total < montoapagar - montoAnticipado) {
        let jsonAnticipado = generaJsonOperacion(
          tblAmorOrig[i].id,
          total,
          "S",
          7
        ); //PAGO PARCIAL MENSUALIDAD
        operaciones.push(jsonAnticipado);

        tblAmorOrig[i].anticipado = Number(
          tblAmorOrig[i].anticipado + total
        ).toFixed(2);
        break;
      } else {
        let jsonMensualidad = generaJsonOperacion(
          tblAmorOrig[i].id,
          montoapagar - montoAnticipado,
          "S",
          3
        ); //PAGO MORATORIO MENSUALIDAD
        operaciones.push(jsonMensualidad);
        tblAmorOrig[i].estatus = "A";
        tblAmorOrig[i].fechapago = dateToString(new Date());
        total = parseFloat(total - (montoapagar - montoAnticipado).toFixed(2));
      }
    }
    if (tblAmorOrig[i].estatus == "P") {
      let now = new Date();
      let e = new Date(tblAmorOrig[i].fechaapagar);
      let limit = new Date();
      limit.setDate(limit.getDate() + 10);

      if (total < montoapagar - montoAnticipado) {
        let jsonAnticipado;
        if (now >= e && now <= limit) {
          //regular
          jsonAnticipado = generaJsonOperacion(
            tblAmorOrig[i].id,
            total,
            "S",
            7
          ); //PAGO PARCIAL MENSUALIDAD
        } else {
          //anticipado
          jsonAnticipado = generaJsonOperacion(
            tblAmorOrig[i].id,
            total,
            "S",
            4
          ); //PAGO ANTICIPADO MENSUALIDAD
        }

        let anticipado = parseFloat(tblAmorOrig[i].anticipado);
        let totalNum = parseFloat(total);
        tblAmorOrig[i].anticipado = parseFloat(
          (anticipado + totalNum).toFixed(2)
        );
        break;
      } else {
        let jsonMensualidad;
        if (now >= e && now <= limit) {
          //
          jsonMensualidad = generaJsonOperacion(
            tblAmorOrig[i].id,
            montoapagar - montoAnticipado,
            "S",
            2
          ); //PAGO REGULAR MENSUALIDAD
        } else {
          jsonMensualidad = generaJsonOperacion(
            tblAmorOrig[i].id,
            montoapagar - montoAnticipado,
            "S",
            4
          ); //PAGO anticipado MENSUALIDAD
        }
        operaciones.push(jsonMensualidad);
        tblAmorOrig[i].estatus = "A";
        tblAmorOrig[i].fechapago = dateToString(new Date());
        let calculoanticipado = parseFloat(
          (montoapagar - montoAnticipado).toFixed(2)
        );
        total = parseFloat((total - calculoanticipado).toFixed(2));
      }
    }
  }

  let processedIds = {};

  for (let i = 0; i < operaciones.length; i++) {
    let idTblAmo = operaciones[i].idTblAmo;

    if (!processedIds.hasOwnProperty(idTblAmo)) {
      for (let j = 0; j < tblAmorOrig.length; j++) {
        if (tblAmorOrig[j].id === idTblAmo) {
          tblNueva.push(tblAmorOrig[j]);
          break;
        }
      }
      processedIds[idTblAmo] = true;
    }
  }

  const tblAmorActualizada = tblAmorOrig.map(item => {
    const { id, ...rest } = tblNueva;
    if (item.id == id) {
      return { id, ...rest };
    }
    return item;
  });

  operaciones.push({ tblUpdate: tblAmorActualizada });
  return reformatData(operaciones);
};
*/
const generaOperacionEstatusM = (total, tblAmorOrig, i, operaciones) => {
  const {
    id,
    interes: originalInteres,
    montoapagar: originalMontoApagar,
    anticipado: originalAnticipado
  } = tblAmorOrig[i];

  const montoInteres = parseFloat(originalInteres) || 0;
  const montoApagar = parseFloat(originalMontoApagar) || 0;
  const montoAnticipado = parseFloat(originalAnticipado) || 0;

  if (montoInteres > 0) {
    let interes = montoInteres;
    let montopagar = montoApagar;
    let totalActualizado;

    if (total - montoInteres <= 0) {
      tblAmorOrig[i].interes = Math.abs(
        parseFloat((total - montoInteres).toFixed(2))
      );
      totalActualizado = total;
    } else {
      tblAmorOrig[i].interes = 0;
      totalActualizado = montoInteres;
      total = parseFloat((total - montoInteres).toFixed(2));
    }

    let jsonInteres = generaJsonOperacion(id, totalActualizado, "E", 5);
    tblAmorOrig[i].moratorio = parseFloat((interes + montopagar).toFixed(2));
    operaciones.push(jsonInteres);
  }

  let jsonMensualidad;

  if (total < montoApagar - montoAnticipado) {
    jsonMensualidad = generaJsonOperacion(id, total, "E", 7);
    tblAmorOrig[i].anticipado = Number(
      tblAmorOrig[i].anticipado + total
    ).toFixed(2);
  } else {
    jsonMensualidad = generaJsonOperacion(
      id,
      montoApagar - montoAnticipado,
      "E",
      3
    );
    tblAmorOrig[i].estatus = "A";
    tblAmorOrig[i].fechapago = dateToString(new Date());
    total = parseFloat(total - (montoApagar - montoAnticipado).toFixed(2));
  }

  operaciones.push(jsonMensualidad);

  return total;
};

const generaOperacionEstatusP = (
  total,
  tblAmorOrig,
  index,
  operaciones,
  fechapago = ""
) => {
  const {
    id,
    fechaapagar,
    montoapagar: originalMontoApagar,
    anticipado: originalAnticipado
  } = tblAmorOrig[index];
  const montoApagar = parseFloat(originalMontoApagar) || 0;
  const montoAnticipado = parseFloat(originalAnticipado) || 0;

  const fechaactual = new Date();
  const fechadepago = new Date(fechaapagar);
  const limitepago = new Date();
  limitepago.setDate(limitepago.getDate() + 10);

  const estaEnLimite = fechaactual >= fechadepago && fechaactual <= limitepago;

  let tipo;
  let jsonMensualidad;
  let monto = total;

  // La fila 0 de la amortización es el enganche
  const esEnganche = id === 0;

  if (total < montoApagar - montoAnticipado) {
    tipo = esEnganche ? 1 : (estaEnLimite ? 7 : 4);
    tblAmorOrig[index].anticipado = parseFloat(
      (parseFloat(tblAmorOrig[index].anticipado) + total).toFixed(2)
    );
    total = 0;
  } else {
    tipo = esEnganche ? 1 : (estaEnLimite ? 2 : 4);
    tblAmorOrig[index].estatus = "A";
    tblAmorOrig[index].fechapago =
      fechapago == "" ? dateToString(new Date()) : fechapago;

    let calculoanticipado = parseFloat(
      (montoApagar - montoAnticipado).toFixed(2)
    );
    monto = calculoanticipado;
    total = parseFloat((total - calculoanticipado).toFixed(2));
  }

  jsonMensualidad = generaJsonOperacion(id, monto, "E", tipo);
  operaciones.push(jsonMensualidad);

  return total;
};

export const generaOperaciones = (
  total,
  tblAmorOrig,
  MetodoPago,
  fechapago = "",
  generaMesesConsecutivos = false
) => {
  let tblNueva = [];

  if (!Array.isArray(tblAmorOrig)) tblAmorOrig = [];
  fechapago = fechapago ? parseafechainicioServicio(new Date(fechapago)) : "";
  total = parseFloat(total) || 0;
  // Ya no generamos fila de "entrada" con método de pago como concepto
  let operaciones = [];

  const JsonMetodosOperacion = {
    M: generaOperacionEstatusM,
    P: generaOperacionEstatusP
  };

  let i = 0;
  while (total > 0 && i < tblAmorOrig.length) {
    const generaOperacionEstatus = JsonMetodosOperacion[tblAmorOrig[i].estatus];
    if (generaOperacionEstatus) {
      total = generaOperacionEstatus(
        total,
        tblAmorOrig,
        i,
        operaciones,
        fechapago
      );
      if (generaMesesConsecutivos) fechapago = addOneMonth(fechapago);
    }
    i++;
  }

  let tblAmorOrigMap = new Map(tblAmorOrig.map(item => [item.id, item]));

  tblNueva = operaciones
    .map(({ idTblAmo }) => tblAmorOrigMap.get(idTblAmo))
    .filter(Boolean);

  const tblAmorActualizada = tblAmorOrig.map(item => {
    const updatedItem = tblNueva.find(({ id }) => id === item.id);
    return updatedItem || item;
  });

  operaciones.push({ tblUpdate: tblAmorActualizada });
  return reformatData(operaciones);
};
